import { createLogic } from 'redux-logic'
import * as constants from '../constants'
import { map, mergeMap, take } from 'rxjs/operators'
import Comps from '@engine/comps'
import { normalize } from '@engine/dependencies'

export const refreshListInfo = createLogic({
  type: constants.REFRESH_LIST_INFO.ACTION,
  processOptions: {
    successType: constants.REFRESH_LIST_INFO.FULFILLED,
    failType: constants.REFRESH_LIST_INFO.REJECTED
  },
  process({ http, action, getState }) {
    const state = getState()
    const polarisPropertySearchCriteriaId = Comps.selectors.comps.polarisPropertySearchCriteriaId(state)
    const omniViewPropertyListId = Comps.selectors.comps.omniViewPropertyListId(state)
    const listName = Comps.selectors.comps.listName(state)
    const resetAllProperties = action.payload?.selectedRefreshOption === '2' && true

    return http
      .post('/api/common/compsList/getListDetails', {
        listDetails: { omniViewPropertyListId, polarisPropertySearchCriteriaId }
      })
      .pipe(
        map(http.getBody),
        map(response => response),
        mergeMap(response => {
          const listInfo = response?.data?.[0]
          const propertyIdList = listInfo?.compsList && listInfo?.compsList?.reduce((prev, cur) => prev.concat(cur.omniViewPropertyId), [])

          return http.post('/comps/photos/query', { propertyIdList })
          .pipe(
            take(1),
            map(http.getBody),
            map(res => ({
              listInfo: normalize.updateListInfo(listInfo, res),
              listName,
              resetAllProperties
            }))
          )
        })
      )
  }
})
